import { render } from "./HeaderMenu.vue?vue&type=template&id=5115dba6&lang=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"

import "./HeaderMenu.vue?vue&type=style&index=0&id=5115dba6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__